const QUERIES = {
  USERS_LIST: 'users',
  GROUPS_LIST: 'groups',
  PROJECTS_LIST: 'projects',
  EVENTS_LIST: 'events',
  NOTIFICATIONS_LIST: 'notifications',
  ASSETS_LIST: 'assets',
  INSPECTION_LIST: 'inspections',
  SITES_LIST: 'sites',
  TRANSACTIONS_LIST: 'transactions',
  ORDERS_LIST: 'orders',
  TAGS_LIST: 'tags',
  INSPECTION_TEMPLATES_LIST: 'templates',
  SUBSCRIPTION_PLANS_LIST: 'subscription_plans',
  INSPECTION_COMPANIES_LIST: 'inspection_companies',
  FREQUENCIES_LIST: 'frequencies',
  PURCHASE_LIST: 'my_purchases',
  CATEGORY_LIST: 'categories',
  DATA_ANONYMIZATION_LIST: 'data_anonymization',
  RESCHEDULE_INSPECTION_LIST: 'rescheduled-inspections',
}

export {QUERIES}
